export { ReactComponent as QuestionsCheckbox } from './svgs/questions-checkbox.svg';
